const PURCHASE_COMPLETED_EVENT = "wa:purchase-completed";

/** Tell the host app a checkout succeeded so it can refresh purchase-dependent UI. */
export const emitPurchaseCompleted = () => {
  window.dispatchEvent(new Event(PURCHASE_COMPLETED_EVENT));
};

/** Subscribe to completed checkouts; returns an unsubscribe function. */
export const onPurchaseCompleted = (handler: () => void) => {
  window.addEventListener(PURCHASE_COMPLETED_EVENT, handler);
  return () => window.removeEventListener(PURCHASE_COMPLETED_EVENT, handler);
};
